module.exports = __webpack_public_path__ + "images/2fddbac245068a2f4f75879f5052a59b.png";